import { LogIn, CheckCircle2, FileText } from "lucide-react";
import { trendPct } from "./utils";

function PulseCard({ icon: Icon, label, current, previous, color }) {
  const trend = trendPct(current, previous);
  const positive = trend > 0;
  const neutral = trend === 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      <div className="flex items-center gap-2 mb-2">
        <div
          className={`w-8 h-8 rounded-lg flex items-center justify-center ${color}`}
        >
          <Icon size={16} className="text-white" />
        </div>
        <span className="text-sm text-gray-600">{label}</span>
      </div>
      <div className="flex items-end justify-between gap-2">
        <p className="text-2xl font-bold text-gray-900">{current}</p>
        <span
          className={`text-xs font-medium pb-1 ${
            neutral
              ? "text-gray-400"
              : positive
              ? "text-emerald-600"
              : "text-red-600"
          }`}
        >
          {neutral ? "=" : positive ? "↑" : "↓"} {Math.abs(trend)}%
        </span>
      </div>
      <p className="text-xs text-gray-400 mt-1">
        7 días anteriores: {previous}
      </p>
    </div>
  );
}

export default function WeeklyPulse({
  loginsThisWeek,
  loginsPrevWeek,
  activitiesThisWeek,
  activitiesPrevWeek,
  documentsThisWeek,
  documentsPrevWeek,
}) {
  return (
    <div>
      <h2 className="text-sm font-semibold text-gray-700 mb-3">
        Pulso de la semana
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <PulseCard
          icon={LogIn}
          label="Logins"
          current={loginsThisWeek}
          previous={loginsPrevWeek}
          color="bg-cyan-500"
        />
        <PulseCard
          icon={CheckCircle2}
          label="Actividades completadas"
          current={activitiesThisWeek}
          previous={activitiesPrevWeek}
          color="bg-emerald-500"
        />
        <PulseCard
          icon={FileText}
          label="Documentos subidos"
          current={documentsThisWeek}
          previous={documentsPrevWeek}
          color="bg-purple-500"
        />
      </div>
    </div>
  );
}
